import script from "./school.vue?vue&type=script&setup=true&lang=js"
export * from "./school.vue?vue&type=script&setup=true&lang=js"

import "./school.vue?vue&type=style&index=0&id=6603bedc&scoped=true&lang=less"

import exportComponent from "D:\\STD7159\\源码管理\\前端\\stgd.oa.ows.inernetweb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6603bedc"]])

export default __exports__